import { render, staticRenderFns } from "./Beneficios.vue?vue&type=template&id=8bd8d826&scoped=true"
import script from "./Beneficios.vue?vue&type=script&setup=true&lang=js"
export * from "./Beneficios.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Beneficios.vue?vue&type=style&index=0&id=8bd8d826&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd8d826",
  null
  
)

export default component.exports